module.exports = __webpack_public_path__ + "acceptancemark-paymentmethod-2.a71e8ec2.svg";